import { ConfirmDialog as ExoConfirmDialog } from "@exopengithub/exokit";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

// Portal wrapper: injects the Swedish default cancel label.
export const ConfirmDialog = (
	props: ComponentProps<typeof ExoConfirmDialog>,
) => {
	const { t } = useTranslation();
	return <ExoConfirmDialog cancelLabel={t("Cancel")} {...props} />;
};
